import { Space } from 'antd';
import styled from 'styled-components';

export const StyledSpace = styled(Space)`
    h3 {
        cursor: pointer;
    }
`;
